import { type ReactElement } from 'react';
import { StatCard, type StatCardProps } from '@vello/web-theme';
import { useT } from '../i18n/provider';
import { type ReadState } from './use-read';

/**
 * A KPI card over one read (D513): a skeleton while the read is in flight, the number counting up when it lands, and the
 * honest "unavailable" when the read failed or was refused — never a quiet zero.
 */
export function CountCard({ label, state, pick, hint, tone }: { label: string; state: ReadState<unknown> | undefined; pick: (value: never) => number; hint?: StatCardProps['hint']; tone?: StatCardProps['tone'] }): ReactElement {
  const { t, lang } = useT();
  const nf = new Intl.NumberFormat(lang);
  if (state === undefined || state.status === 'loading') return <StatCard label={label} value="" loading loadingLabel={t('ui.loading')} />;
  if (state.status === 'error') return <StatCard label={label} value={t('ui.unavailable')} />;
  const n = pick(state.value as never);
  return <StatCard label={label} value={nf.format(n)} count={{ value: n, format: (v) => nf.format(v) }} {...(hint !== undefined ? { hint } : {})} {...(tone !== undefined ? { tone } : {})} />;
}
